export default [
    {
        path: "/program-details/:id/:tabName?",
        name: "ProgramDetails",
        component: () => import("@/views/Page/StrategicPlan/Program/ProgramDetails.vue"),
        meta: {
            title: "ProgramDetails",
            permission: "Program.show",
        },
    },
];
